import agence19 from '../images/companies/agence19.png';
import yassir from '../images/companies/yassir.webp';
import iec from '../images/companies/iec.png';
import ecomx from '../images/companies/ecomx.png';
import slb from '../images/companies/slb.png';
import technocolabsoftwares from '../images/companies/technocolabsoftwares.png';

const  companies = [
    {
        id: "6",
        title: "SLB (ex-Schlumberger)",
        imgSrc: slb,
        work: ['Working on drilling insight extraction and Drilling risk prediction from drilling daily reports (DDR)'],
        myPosition: ["Artificial Intelligence Intern"],
        date: "03/2025 - Present",
        iconColor: '#0014dc',
        class:"sm:w-[400px] sm:pt-[10px] pt-[5px]",

    },
    {
        id: "5",
        title: "EcomX",
        imgSrc: ecomx,
        work: ['I worked on Development of a custom AI voice bot with unique voice signature, integrated into a webinar platform to automate and personalize voice interactions.'],
        myPosition: ["Data Scientist Intern"],
        date: "12/03/2024 - Present",
        iconColor: '#E29537',
        class:"sm:w-[300px] w-[50px] sm:pt-[50px]",        
    },
    {
        id: "5",
        title: "TechnoColabs Softwres",
        imgSrc: technocolabsoftwares,
        work: ['I work on Building Machine Learning Pipeline on Startup Acquisition Status,where i cover these main points : Data analysis / Preprocessing of data,Exploratory Data Analysis (EDA) / Feature Extraction,ML models/Machine Learning Pipeline / Deployment'],
        myPosition: ["Machine Learning Intern"],
        date: "06/2024 - 08/2024",
        iconColor: '#011D9B',
        class:"sm:w-[500px] sm:pt-[50px] pt-[5px]",

    },
    {
        id: "4",
        title: "Agence19",
        imgSrc: agence19,
        work: ['I worked on Development of a secure facial recognition access application using deep learning Siamese model.'],
        myPosition: ["Artificial Intelligence Intern"],
        date: "03/2024 - 04/2024",
        iconColor: '#61b8ff',
        class:"sm:w-[500px] sm:pt-[50px] pt-[5px]",

    },
    {
        id: "3",
        title: "Agence19",
        imgSrc: agence19,
        work: ['I work on building websites with wordpress (Elementor,Divi) and with HTML/CSS/JS for the frontend and PHP/MySQL for the backend.'],
        myPosition: ["front-end web developer"],
        date: "01/2023 - 08/2023",
        iconColor: '#61b8ff',
        class:"sm:w-[500px] sm:pt-[50px] pt-[5px]",

    },
    {
        id: "2",
        title: "Industrial Engineers Club",
        imgSrc: iec,
        work: ['In IEC i worked on the part of front-end with Laravel/VueJS and tailwind css for the development of a software named "Bussiness Game" that simulates a competitive market'],
        myPosition: ["front-end web Developer"],
        date: "03/2023 - 05/2023",
        iconColor: '#132131',
        class:"w-[500px] sm:pt-[50px]",

    },
    {
        id: "1",
        title: "YASSIR",
        imgSrc: yassir,
        work: ['In yassir intership i had the chance to visit every signle department : (Crea,IT,Product,Marketing,Data Science..),and get the basic notions about Database Mangement'],
        myPosition: ["Discovery intership"],
        date: "12/2022 - 01/2023",
        iconColor: '#FB2477',
        class:"sm:w-[400px] sm:pt-[50px] pt-[10px]",

    },
    
    
]
export default companies;

